import Schema from "async-validator";
import numberjs from "@/assets/js/numberjs";
import { convertDecimal } from "@/assets/js/convert";

// MessageConfig
const messageConfig = require("@/models/messageConfig");

// MediaNett自定义验证
const MediaNettValidation = (rule, value) => {

  return convertDecimal(value.mediaNett) === convertDecimal(value.nettItemSum);
};

// 制作费用类型自定义验证
const ProductionCostTypeValidation = (rule, value) => {
  return (
    parseFloat(value.piCost) === 0 ||
    (parseFloat(value.piCost) > 0 && (value.productionCostType || "") !== "")
  );
};

// 服务费用类型自定义验证
const SalesServiceTypeValidation = (rule, value) => {
  return (
    parseFloat(value.salesServiceFee) === 0 ||
    (parseFloat(value.salesServiceFee) > 0 && (value.salesServiceType || "") !== "")
  );
};

// 预付制作费用结束日期自定义验证
const AdditionalEndDateValidation = (rule, value) => {
  return (
    parseFloat(value.additionalProduction) === 0 ||
    (parseFloat(value.additionalProduction) > 0 && (value.additionalProductionEndDate || "") !== "")
  );
};

// 特殊佣金安排自定义验证
const SpecialComValidation = (rule, value, callback, source) => {
  var validation = true;

  // if (value.SpecialCommissionList.length > 0) {
  //   validation = !(
  //     value.SpecialCommissionList.map((t) => {
  //       const splitMedia = source.SplitMedias.find(a => a.splitMediaId === t.splitMediaId)

  //       const mediasum =
  //         parseFloat(splitMedia?.nettItemSum || 0) + parseFloat(splitMedia?.totalProductionCost || 0);
  //       const commissionsum =
  //         parseFloat(t.mediaCost) +
  //         parseFloat(t.productionCost);
  //       return mediasum.toFixed(2) !== commissionsum.toFixed(2);
  //     }).find((t2) => t2) || false
  //   );
  // }

  return validation;
};

const SalesServiceFeeValidation = (rule, value) => {
  return (
    (convertDecimal(value.salesServiceFee) === convertDecimal(value.serviceFee))
  );
}

// 数字类型自定义验证
const NumberValidation = (rule, value) => {
  return value !== "" && parseFloat(value) !== "NaN" && !isNaN(value);
};

// 分拆信息验证规则
const ContractSplitRule = {
  productionCostType: {
    message: messageConfig.getMessage("validformrequire"),
    validator: ProductionCostTypeValidation,
  },
  salesServiceType: {
    message: messageConfig.getMessage("validformrequire"),
    validator: SalesServiceTypeValidation,
  },
  additionalProductionEndDate: {
    message: messageConfig.getMessage("validformrequire"),
    validator: AdditionalEndDateValidation,
  },
  mediaNett: {
    message: messageConfig.getMessage("validmedianett"),
    validator: MediaNettValidation,
  },
  specialCommission: {
    message: messageConfig.getMessage("commissionnomatch"),
    validator: SpecialComValidation,
  },
  salesServiceFee: {
    message: messageConfig.getMessage("validservicefee"),
    validator: SalesServiceFeeValidation
  }
};

// 分拆信息输入验证规则
const ContractSplitInputRule = {
  mediaNett: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  salesServiceFee: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  additionalProduction: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
};

// 分拆媒体验证规则
const ContractSplitMediaRule = {
  dates: {
    type: "array",
    require: true,
  },
  loading: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  nettItemSum: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  unitProductionCost: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  mediaTotalInternalSplit: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  productionTotalInternalSplit: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  serviceFee: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
};

// 制作费分拆输入规则
const ProductionSplitInputRule = {
  productionCost: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  repaintingCost: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  dismantleCost: {
    require: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  },
  repairCost: {
    required: true,
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation,
  }
}

// 特殊佣金安排更新验证
const SpecialCommissionInputRule = {
  mediaCost: {
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation
  },
  productionCost: {
    type: "number",
    message: messageConfig.getMessage("moneyerror"),
    validator: NumberValidation
  }
}

var errors;

const intlslitValidation = {
  /**
   * 分拆信息验证
   * @param {*} Split
   * @param {*} SplitMedias
   * @returns
   */
  async ContractSplitVaidation (Split, SplitMedias, SpecialCommissionList) {

    var ErrorMessage;

    var nettItemSum = 0;
    var serviceFee = 0
    if (SplitMedias.length > 0) {
      nettItemSum = numberjs.Sum(SplitMedias.map(t => parseFloat(t.nettItemSum)))
      serviceFee = numberjs.Sum(SplitMedias.map(t => parseFloat(t.serviceFee)))
    }


    const source = {
      productionCostType: {
        piCost: Split.piCost,
        productionCostType: Split.productionCostType
      },
      salesServiceType: {
        salesServiceFee: Split.salesServiceFee,
        salesServiceType: Split.salesServiceType
      },
      additionalProductionEndDate: {
        additionalProduction: Split.additionalProduction,
        additionalProductionEndDate: Split.additionalProductionEndDate
      },
      mediaNett: {
        mediaNett: Split.mediaNett,
        nettItemSum: nettItemSum
      },
      salesServiceFee: {
        salesServiceFee: Split.salesServiceFee,
        serviceFee: serviceFee
      },
      specialCommission: {
        SpecialCommissionList,
      },
      SplitMedias
    }


    var validator = new Schema(ContractSplitRule);

    await validator
      .validate(source)
      .then(() => {
        return true;
      })
      .catch((errs) => {
        ErrorMessage = errs.errors;
      });



    return ErrorMessage;
  },
  /**
   * 验证不通过信息
   * @returns
   */
  ContractSplitValidationMessage () {
    return errors?.[0]?.message || "";
  },
  /**
   * 分拆媒体信息验证
   * @param {Object} source 验证的信息
   * @returns
   */
  async ContractSplitMediaValidation (source) {
    var validator = new Schema(ContractSplitMediaRule);

    var errorsResult;

    await validator
      .validate(source)
      .then(() => {
        return true;
      })
      .catch((errs) => {
        errorsResult = errs.errors;
      });

    return errorsResult;
  },
  /**
   * 分拆信息输入验证
   * @param {Object} source
   * @returns
   */
  async ContractSplitInputVlidation (source) {
    var validator = new Schema(ContractSplitInputRule);

    var errorsResult;

    await validator
      .validate(source)
      .then(() => {
        return true;
      })
      .catch((errs) => {
        errorsResult = errs.errors;
      });

    return errorsResult;
  },
  /**
   * 制作费分拆输入验证
   * @param {Object} source
   * @returns
   */
  async ProductionSplitInputValidation (source) {
    var validator = new Schema(ProductionSplitInputRule);

    var errorsResult;

    await validator
      .validate(source)
      .then(() => {
        return true;
      })
      .catch((errs) => {
        errorsResult = errs.errors;
      });

    return errorsResult;
  },
  /**
  * 特殊佣金安排输入验证
  * @param {Object} source
  * @returns
  */
  async SpecialCommissionInputValidation (source) {
    var validator = new Schema(SpecialCommissionInputRule);

    console.log("source", source);

    var errorsResult;

    await validator
      .validate(source)
      .then(() => {
        return true;
      })
      .catch((errs) => {
        errorsResult = errs.errors;
      });

    console.log("errorsResult", errorsResult)
    return errorsResult || [];
  }
};

export default intlslitValidation;
